import { cardStatusTranslation } from "./cardStatusTranslation.constant";

export const cardStatusAvailableToConsumption: Partial<keyof typeof cardStatusTranslation>[] = [
  'active',
  'shipped',
];
